<template>
  <svg width="800px" height="396px" viewBox="0 0 800 396" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
          <linearGradient x1="1.06476664%" y1="100%" x2="14.4284751%" y2="100%" id="linearGradient-1">
              <stop stop-color="#5263FF" offset="0%"></stop>
              <stop stop-color="#0BBFB0" offset="100%"></stop>
          </linearGradient>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-2">
              <stop stop-color="#0BBFB0" offset="0%"></stop>
              <stop stop-color="#FFFFFF" offset="100%"></stop>
          </linearGradient>
          <linearGradient x1="50%" y1="62.503104%" x2="50%" y2="3.061617e-15%" id="linearGradient-3">
              <stop stop-color="#FFFFFF" offset="0%"></stop>
              <stop stop-color="#0BBFB0" offset="100%"></stop>
          </linearGradient>
          <linearGradient x1="52.5183741%" y1="50%" x2="0%" y2="50%" id="linearGradient-4">
              <stop stop-color="#FFFFFF" offset="0%"></stop>
              <stop stop-color="#0BBFB0" offset="100%"></stop>
          </linearGradient>
      </defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Policy-Portal-Stocktake-unroll" transform="translate(-107, -581)">
              <g id="Group-4" transform="translate(109, 548)">
                  <a href="#/stocktake-1"><circle fill="#C5FFFA" cx="261" cy="187" r="70"></circle></a>
                  <a href="#/transition-path-1"><circle fill="#C5FFFA" cx="446" cy="200" r="98"></circle></a>
                  <a href="#/land-affected"><circle fill="#C5FFFA" cx="698" cy="207" r="71"></circle></a>
                  <path d="M10,250 L75.8356808,250 C86.329091,250 94.8356808,241.49341 94.8356808,231 L94.8356808,187 C94.8356808,176.50659 103.342271,168 113.835681,168 L144.659811,168 L144.659811,168 L705,168" id="Path-17" stroke="url(#linearGradient-1)"></path>
                  <path d="M157,168 L235.412809,168 L235.512842,168 C247.110821,168 256.512842,177.40202 256.512842,189 C256.512842,200.59798 265.914862,210 277.512842,210 L315.547448,210 C327.145428,210 336.547448,200.59798 336.547448,189 C336.547448,177.40202 345.949469,168 357.547448,168 L386.12342,168 C397.721399,168 407.12342,177.40202 407.12342,189 C407.12342,200.59798 416.52544,210 428.12342,210 L565.109904,210 C576.707883,210 586.109904,200.59798 586.109904,189 C586.109904,177.40202 595.511924,168 607.109904,168 L682,168 L682,168" id="Path-18" stroke="#0BBFB0"></path>
                  <a href="#/primer"><circle stroke="#FFFFFF" stroke-width="2" fill="#5263FF" cx="9" cy="250" r="10"></circle></a>
                  <g class="label">
                    <text transform="translate(245, 150) rotate(-45)" fill="#0BBFB0">Global Stocktake I</text>
                    <a href="#/stocktake-1"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="234" cy="168" r="10"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(299, 195) rotate(-45)" fill="#0BBFB0">Global Stocktake II</text>
                    <a href="#/stocktake-2"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="291" cy="210" r="10"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(375, 150) rotate(-45)" fill="#0BBFB0">Towards an Electric <tspan x="6.40990258" y="15">Future</tspan></text>
                    <a href="#/transition-path-1"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="365" cy="168" r="10"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(465, 198) rotate(-45)" fill="#0BBFB0">Sector Transition II</text>
                    <a href="#/transition-path-2"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="455" cy="210" r="10"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(545, 198) rotate(-45)" fill="#0BBFB0">Land Transitions</text>
                    <a href="#/land-transitions"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="528" cy="210" r="10"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(495, 240) rotate(-45)" fill="#0BBFB0">Primary Energy</text>
                    <a href="#/primary-energy"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="484" cy="245" r="7"></circle></a>
                  </g>
                  <g class="label">
                    <text transform="translate(715, 150) rotate(-45)" fill="#0BBFB0">Extreme Events</text>
                    <a href="#/land-affected"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="698" cy="168" r="10"></circle></a>
                  </g>
                  <text id="PRIMER" transform="translate(40.909903, 201.989592) rotate(-45) translate(-40.909903, -201.989592) "  fill="#5263FF">
                      <tspan x="6.40990258" y="206.989592">PRIMER</tspan>
                  </text>
                  <text id="BUDGET" transform="translate(337, 96) rotate(-45) translate(-337, -96)" fill="#0BBFB0">
                      <tspan x="299" y="101">BUDGET</tspan>
                  </text>
                  <text id="TRANSITIONS" transform="translate(552, 56) rotate(-45) translate(-552, -56) "  fill="#0BBFB0">
                      <tspan x="483" y="61">TRANSITIONS</tspan>
                  </text>
                  <text id="EXTREME-EVENTS" transform="translate(788, 104) rotate(-45) translate(-788, -104) "  fill="#0BBFB0">
                      <tspan x="735" y="100">EXTREME </tspan>
                      <tspan x="735" y="118">EVENTS</tspan>
                  </text>
                  <path d="M455,209 L455,232 C455,239.179702 460.820298,245 468,245 L484,245 L484,245" id="Path-19" stroke="#0BBFB0" stroke-dasharray="2"></path>
                  <line x1="698.666667" y1="208.815789" x2="698.666667" y2="332" id="Path-36" stroke="url(#linearGradient-2)" stroke-dasharray="2"></line>
                  <path d="M699,168 L699,191 C699,198.179702 704.820298,204 712,204 L743,204 L743,204" id="Path-19-Copy" stroke="#0BBFB0" stroke-dasharray="2"></path>
                  <!-- <path d="M699,191 L699,212 C699,219.179702 704.820298,225 712,225 L743,225 L743,225" id="Path-19-Copy-2" stroke="#0BBFB0" stroke-dasharray="2"></path> -->
                  <g class="label">
                    <text transform="translate(750, 195) rotate(-45)" fill="#0BBFB0">Earth</text>
                    <a href="#/earth"><circle stroke="#C5FFFA" stroke-width="2" fill="#0BBFB0" cx="741.5" cy="204.5" r="6.5"></circle></a>
                  </g>
                  <path d="M365,169 L365,264.366197 C365,274.859607 356.49341,283.366197 346,283.366197 L169,283.366197 C158.50659,283.366197 150,291.872787 150,302.366197 L150,401 L150,401" id="Path-34" stroke="url(#linearGradient-3)" stroke-dasharray="2"></path>
                  <path d="M529,210 L529,293.407407 C529,302.243963 536.163444,309.407407 545,309.407407 L683,309.407407 C691.836556,309.407407 699,316.570851 699,325.407407 L699,430 L699,430" id="Path-35" stroke="url(#linearGradient-4)" stroke-dasharray="2"></path>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["isMobile"])
  }
};
</script>

<style scoped lang="scss">
svg {
  margin: 50px 0;

  .label {
    font-size: 14px;
    fill-opacity: 0;
     circle {
       stroke: #0bbfb0;
     }

    text {
      fill: #5263FF;
    }
  }
  .label:hover {
    fill-opacity: 1;
  }
}
tspan, text {
  font-size: 14px;
}
</style>
